export default __webpack_public_path__ + "static/media/no-form.5f5bdf6d.svg";